export const makeLabel = (performance) => {
    const date = new Date(performance?.performanceDateTime);
    const time = date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', timeZone: 'America/Chicago' });
    return time;
};

export const makeTitle = (performance, title, soldOut = false) => {
    const localString = new Date(performance?.performanceDateTime).toLocaleString('en-US', {
        timeZone: 'America/Chicago',
    });
    if (soldOut) return `This departure is sold out.`;
    if (performance.expired) return `This departure is no longer available for purchase.`;
    if (!soldOut) return `You are selecting the depature for ${title} on ${localString}.`;
};
